import axios from "axios";

const getRoomsApi = process.env.REACT_APP_API_URL + "/api/get-rooms-list";
const createRoomApi = process.env.REACT_APP_API_URL + "/api/create-room";
const editRoomApi = process.env.REACT_APP_API_URL + "/api/edit-room";
const generateGuestKeyApi =
  process.env.REACT_APP_API_URL + "/api/generate-room-guest-key";
const validateGuestKeyApi =
  process.env.REACT_APP_API_URL + "/api/validate-room-guest-key";

/**
 * Gets the JWT token from cookies
 * @returns {string|null} The JWT token or null if not found
 */
const getAuthToken = () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("_auth="))
    ?.split("=")[1];
  return token;
};

const fetchRooms = async () => {
  try {
    const response = await axios.get(getRoomsApi);
    return response.data;
  } catch (error) {
    console.error("Error fetching Rooms:", error);
    throw error;
  }
};

const createRoom = async (roomData) => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error("Authentication required");
    }

    const response = await axios.post(createRoomApi, roomData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Room:", error);
    throw error;
  }
};

const editRoom = async (roomData) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Authentication required");
  }
  const response = await axios.post(editRoomApi, roomData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
  return response.data;
};

/**
 * Generate a guest access key for a specific room
 * @param {number} roomId - The ID of the room
 * @param {number} expiryHours - Hours until the key expires (optional, default 24)
 * @returns {Promise<Object>} - Response containing guest key and URL
 */
const generateRoomGuestKey = async (roomId, expiryHours = 24) => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error("Authentication required");
    }

    const response = await axios.post(
      generateGuestKeyApi,
      {
        roomId: roomId,
        expiryHours: expiryHours,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error generating guest key:", error);
    throw error;
  }
};

/**
 * Validate a guest access key for a specific room
 * @param {number} roomId - The ID of the room
 * @param {string} guestKey - The guest key to validate
 * @returns {Promise<Object>} - Validation result
 */
const validateRoomGuestKey = async (roomId, guestKey) => {
  try {
    const response = await axios.post(validateGuestKeyApi, {
      roomId: roomId,
      guestKey: guestKey,
    });
    return response.data;
  } catch (error) {
    console.error("Error validating guest key:", error);
    throw error;
  }
};

export { fetchRooms, createRoom, editRoom, generateRoomGuestKey, validateRoomGuestKey };
